// Skips browser-automation sessions in the recorders. cx-e2e-automation's
// Playwright runs were being captured as billed replays nobody watches.
//
// Separate from internal-user.ts on purpose: that asks "is this a Plivo employee",
// this asks "is this a human". Composed at the call site, so SER-6151 is untouched.
//
// navigator.webdriver is set per the WebDriver spec by Playwright, Selenium and
// Puppeteer alike. Unknown state reads as human and records — losing a recording is
// cheaper than silently dropping real sessions.
export const isAutomatedSession = (): boolean => {
  try {
    if (navigator.webdriver === true) return true

    // Second signal; no shipping browser puts "Headless" in its UA.
    return /HeadlessChrome|Headless/i.test(navigator.userAgent)
  } catch {
    return false
  }
}
